import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MyLink } from '@/components/MyLink';
import { APP_LINKS } from '@/helpers/links';
import IconLoop from './icon_loop.svg';
import r from '@/kit/RoundButton/button.module.scss';
import s from './index.module.scss';

export const EmptyContent = () => {
  const { t } = useTranslation('streak');
  return (
    <div className={s.wrapper}>
      <div className={s.icon}>
        <img src={IconLoop} alt="empty" width={24} height={24} />
      </div>
      <div className="f-article-accent">
        {t('empty_content.your_journey_hasnt_started_yet')}
      </div>
      <div
        className="f-small-regular"
        style={{ color: 'var(--Black-100, #414141)' }}
      >
        {t('empty_content.invest_this_month')}
      </div>
      <MyLink
        className={classnames(r.black_small, s.button)}
        href={APP_LINKS.investing}
      >
        {t('empty_content.start_investing')}
      </MyLink>
    </div>
  );
};
